import React, { useState } from 'react';

// Standalone admin login (env-credential auth — see server middleware/adminAuth.js).
export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await fetch('/api/admin/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) { onSuccess(); return; }
      setError(data.error || 'Login failed.');
    } catch (_) {
      setError('Network error. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl shadow-sm p-6 border border-gray-200">
        <h1 className="text-xl font-semibold text-gray-900 mb-1">eHandshake Admin</h1>
        <p className="text-sm text-gray-500 mb-5">Sign in to continue.</p>

        <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          autoComplete="username"
          className="w-full mb-3 px-3 py-2 rounded-lg border border-gray-300 focus:border-[#00aef7] focus:ring-1 focus:ring-[#00aef7] outline-none"
        />

        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          className="w-full mb-4 px-3 py-2 rounded-lg border border-gray-300 focus:border-[#00aef7] focus:ring-1 focus:ring-[#00aef7] outline-none"
        />

        {error && <div className="mb-3 text-sm text-red-600">{error}</div>}

        <button
          type="submit"
          disabled={busy}
          className="w-full py-2 rounded-lg bg-[#00aef7] text-white font-semibold disabled:opacity-60"
        >
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
